<!-- 表二列表 -->

<template>
  <div class="ListCage ssTab4">
    <div class="tabTtl">
      <span>人员基本信息</span>
      <div class="tabBtns">
        <el-button v-if="modifyFlag" type="primary" @click="memberEdit(1)" size="mini">添加</el-button>
        <a :href="excelModeUrl" download>
          <el-button size="mini"> 下载模板</el-button>
        </a>
        <el-button v-if="modifyFlag" @click="ExHandle" type="primary" class="excelRead" size="mini"
          >导入Excel</el-button
        >
        <el-button @click="goBack" size="mini">返回</el-button>
        <ExcelIn
          ref="ExcelSet"
          @t-frash="goFresh"
          @excel-errors="errorCtrls"
          pressType="3"
          :pressId="querys.pressId"
          excelCode="404" />
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="ctrlsLine">
      <!-- @change="tabSeek" -->
      <el-radio-group v-model="seekPms.type">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">主要负责人</el-radio>
        <el-radio :label="2">其他负责人</el-radio>
        <el-radio :label="3">编辑人员</el-radio>
      </el-radio-group>
      <el-input
        v-model="seekPms.keyword"
        size="small"
        placeholder="通过姓名，身份证号（军官证号），手机号查询"></el-input>
      <!-- <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button> -->
      <el-button v-if="modifyFlag" class="dangerBtns" size="small" @click="memberDet(1)" type="warning">删除</el-button>
      <el-button v-if="modifyFlag" class="dangerBtns" @click="memberClean" size="small" type="danger"
        >清除全部</el-button
      >

      <div class="tips">注：请填写此连续型出版物的全部编辑人员</div>
    </div>

    <div class="tabForms">
      <el-table :data="tabDat" border style="width: 100%" @selection-change="selectionChange" v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="fullName" label="姓名" width="120" align="center"> </el-table-column>
        <el-table-column label="性别" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender | translate("C017", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号（军官证号）" width="270" align="center"> </el-table-column>
        <el-table-column label="职务" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.job | translate("C022", dicMap, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="政治面貌" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.politicalStatus | translate("C006", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="文化程度" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.culture | translate("C005", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="major" label="专业" width="90" align="center"> </el-table-column>
        <el-table-column label="职称系列" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.professionalTitleSeries | translate("C007", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="职称级别" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.titleLevel | translate("C008", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="是否持有岗位培训资格证书" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type != 3" class="imgIcon" @click="urlCreate('open', scope.row.trainCertificateId)">
              {{ scope.row.isTrainCertificate | translate("C018", dicMap) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="持有出版专业职业资格证书情况" align="center">
          <template slot-scope="scope">
            <span class="imgIcon" @click="urlCreate('open', scope.row.professionalCertificateId)">
              {{ scope.row.certificateSituation | translate("C009", dicMap) }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否持有岗位培训资格证书" align="center">
        <template slot-scope="scope">
	                   	    {{ scope.row.isTrainCertificate|translate('C018',dicMap) }}
                      	                   </template>
                            </el-table-column> -->
        <el-table-column prop="cellphone" label="手机号" align="center"> </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-if="!modifyFlag" type="primary" @click="memberEdit(2, scope.row)" size="mini">查看</el-button>
            <el-button v-if="modifyFlag" type="primary" @click="memberEdit(2, scope.row)" size="mini">编辑</el-button>
            <el-button v-if="modifyFlag" type="danger" @click="memberDet(2, scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="saveBtn">
      <el-button style="float: left" size="small" @click="goBack">返回</el-button>
      <el-button v-if="modifyFlag" type="primary" size="small" @click="postDeclareFun">保存</el-button>
    </div>
    <ExError ref="chinldError" :errorList="excelEr" pressCode="404"></ExError>
  </div>
</template>

<script>
import {
  ssList4,
  ssRemove4,
  ssClean4,
  submitDeclare, // zym.保存页面申报人信息
  getLxdzModifyFlagByPublication, // zym.判断数据是否可以修改
} from "@/api/pressRole/pressSuccessive";
import ExcelIn from "@/views/components/excelRead/excel";
import ExError from "@/views/components/excelRead/excelError";
import { mapGetters } from "vuex";
export default {
  components: {
    ExcelIn,
    ExError,
  },
  computed: {
    ...mapGetters(["token"]),
  },
  data() {
    return {
      querys: {
        pressId: "",
        mtId: "",
        pgress: "",
        listId: "",
        bookName: "",
      },
      excelModeUrl: "",
      loading: false,
      tabDatAll: [], // zym.所有的数据
      tabDat: [], // zym.列表上的数据
      detArrs: [],
      dicMap: {},
      seekPms: {
        type: 0,
        keyword: "",
        no: 1,
        size: 15,
      },

      excelEr: [],
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",

      modifyFlag: false,
    };
  },
  filters: {
    translate: function (dat, code, transMap, rowDat) {
      if (code == "C022" && transMap[code][dat] == "其他") {
        console.log(rowDat);
        return rowDat.professionalOther;
      } else {
        return transMap[code][dat];
      }
    },
  },
  watch: {
    seekPms: {
      deep: true, //实现深度监听
      handler(v) {
        this.filterTableData();
      },
    },
  },
  methods: {
    /*
     *提交申报人信息
     * */
    postDeclareFun: function () {
      let that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('请填写正确的手机号');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      submitDeclare({
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare,
      })
        .then((response) => {
          console.log("response=", JSON.stringify(response));
          that.submiting = false;
          let tipCode = response.payload.tipCode;
          let tipMessage = response.payload.tipMessage;
          if (tipCode == "fail") {
            that.$message({
              message: tipMessage,
              type: "error",
            });
            return;
          }
          this.$message({
            message: "保存成功！",
            type: "success",
          });

          this.goBack();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tabSeek: function (type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      // ssList4(this.seekPms).then(response => {
      ssList4({
        publishMaterialId: this.$route.query.mtId,
        judgeModify: true,
      }).then((response) => {
        let vm = this;
        setTimeout(function () {
          vm.loading = false;
          // console.log('response=',JSON.stringify(response))
          // vm.tabDat = response.plxdzWorkerList;
          vm.tabDatAll = response.plxdzWorkerList;
          vm.modifyFlag = response.modifyFlag;
          console.log("modifyFlag=", vm.modifyFlag);

          vm.filterTableData();
        }, 300);
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    // zym.过滤列表数据
    filterTableData: function () {
      let tabDat = this.tabDatAll;
      let qType = this.seekPms.type;
      let qKeyword = this.seekPms.keyword;
      // !人员类型
      if (qType) {
        tabDat = tabDat.filter(function (item) {
          if ((item.type || "") == qType) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDat = tabDat.filter(function (item) {
          if (
            (item.fullName || "").indexOf(qKeyword) > -1 ||
            (item.idNumber || "").indexOf(qKeyword) > -1 ||
            (item.cellphone || "").indexOf(qKeyword) > -1
          ) {
            return true;
          }
          return false;
        });
      }

      this.tabDat = tabDat;
    },
    // zym.删除数据 type=1勾选删除   type=2行记录删除
    memberDet: function (type, dat) {
      let detSure = false;
      let vm = this;

      if (type == 1) {
        if (this.detArrs.length > 0) {
          detSure = true;
        } else {
          this.$message.error("请勾选人员！");
        }
      } else if (type == 2) {
        detSure = true;
      }

      if (detSure) {
        this.$confirm("确定删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {};
            if (type == 1) {
              params.ids = vm.detArrs;
            } else if (type == 2) {
              params.ids = [dat.id];
            }

            params.publishMaterialId = this.$route.query.mtId;
            ssRemove4(params)
              .then((response) => {
                let tipCode = response.tipCode;
                let tipMessage = response.tipMessage || "操作失败";
                if (tipCode == "fail") {
                  this.$message({
                    showClose: true,
                    message: tipMessage,
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: tipMessage,
                    type: "success",
                  });
                  this.tabSeek();
                }
              })
              .catch((error) => {});
          })
          .catch(() => {});
      }
    },
    memberClean: function () {
      this.$confirm("此操作会删除所有已录入数据库的人员信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ssClean4({
            type: this.$route.query.pressType,
            publishMaterialId: this.$route.query.mtId,
          }).then((response) => {
            console.log("response=", JSON.stringify(response));
            let tipCode = response.tipCode;
            let tipMessage = response.tipMessage || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.seekPms.type = 0;
              this.keyword = "";
              this.no = 1;
              this.tabSeek();
            }
          });
        })
        .catch(() => {});
    },
    selectionChange: function (selection) {
      let newArr = [];
      for (let i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function () {
      let nameArr = ["C022", "C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map",
      });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    // zym.新增、编辑人员基本信息
    // zym.type：类型 新增-1  编辑-2
    memberEdit: function (type, dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pgress: type,
        listId: this.$route.query.listId,
        mtcode: this.$route.query.mtcode,

        modifyFlag: this.$route.query.modifyFlag, // zym.是否可以修改
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_ssTab4",
        query: pathParams,
      });
    },

    ExHandle: function () {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function (val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goFresh: function () {
      this.tabSeek("init");
    },

    goBack: function () {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function () {
      console.log("getLxdzModifyFlagByPublication...");
      let vm = this;
      getLxdzModifyFlagByPublication({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
      }).then((response) => {
        vm.modifyFlag = response.payload;
      });
    },
  },
  created: function () {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.querys.pressId = this.$route.query.pressId;
    this.querys.mtId = this.$route.query.mtId;
    this.querys.pgress = this.$route.query.pgress;
    this.querys.listId = this.$route.query.listId;
    this.querys.bookName = this.$route.query.bookName;

    this.seekPms.publishMaterialId = this.$route.query.mtId;

    // this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=404&token=' + encodeURIComponent(this.token);
    this.excelModeUrl = process.env.URL_FILE + "/drmb/208_404.xlsx";
    // this.excelModeUrl = process.env.BASE_API + '/drmb/208_404.xlsx';
    this.dictInit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.ssTab4 {
  .saveBtn {
    margin: 50px 400px;

    .el-button {
      width: 150px;
      margin-right: 10px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 20px;
  }

  .editArea {
    table {
      width: 80%;
      margin: 30px auto;

      tr {
        display: block;
        margin-top: 20px;
      }

      .edName {
        width: 300px !important;
        text-align: right;
      }

      .edInp {
        padding-left: 15px;

        .el-input {
          width: 300px;
        }
      }
    }
  }

  .editArea table .edName {
    width: 210px;
  }

  .el-button + .el-button {
    margin-left: 0px;
  }

  .ctrlsLine {
    padding: 12px;

    .tips {
      font-size: 12px;
      margin-top: 12px;
      color: salmon;
    }

    .el-radio__label {
      margin-left: -5px;
    }

    .el-input {
      display: inline-block;
      width: 360px;
      margin-left: 20px;

      input {
        border-radius: 0;
      }
    }

    .el-button + .el-button {
      margin-left: 0;
    }

    .el-radio + .el-radio {
      margin-left: 20px;
    }

    .seekBtn {
      margin-right: 20px;
    }

    .excelRead {
      float: right;
    }
  }

  .tabForms {
    .el-button + .el-button {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ssTab4.vue?675be35a